import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import { listenForInstallPrompt } from "./components/atomic-crm/pwa/installPrompt";
import { notifyUpdateAvailable } from "./components/atomic-crm/pwa/serviceWorkerUpdate";

// The install prompt can fire before React mounts: start listening right away.
listenForInstallPrompt();

// A new deploy waits until the user accepts the "new version" prompt.
const updateServiceWorker = registerSW({
  onNeedRefresh: () => notifyUpdateAvailable(updateServiceWorker),
});

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
